<template>
  <div>
    <router-view></router-view>
    <van-tabbar route :active-color="basic.tabbar_active_color?basic.tabbar_active_color:'#ee0a24'" v-if="isShow_menu">
      <van-tabbar-item replace to="/m/" icon="home-o">首页</van-tabbar-item>
      <van-tabbar-item replace to="/m/query" icon="search">订单查询</van-tabbar-item>
      <van-tabbar-item replace to="/m/group" icon="apps-o">分类</van-tabbar-item>
    </van-tabbar>

    <div class="page-suspend">
      <!-- <div class="item" @click="$router.push('/m/query')">
        <span class="iconfont icon-dingdanchaxun"></span>
        <p>订单查询</p>
      </div> -->
      <a :href="basic.help_qq">
        <div class="item">
          <span class="iconfont icon-lianxikefu"></span>
          <p>联系客服</p>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
  import {
    getSystem,
  } from "@/api/index";
  import {
    Dialog,
    Notify,
  } from "vant";
  export default {
    data() {
      return {
        basic: {},
        isShow_menu: true
      }
    },
    created() {
      this._getSystem()
    },
   
    methods: {
      // 获取设置
      _getSystem() {
        getSystem().then((res) => {
          this.basic = res.data;
          this.isShow_menu = res.data.isShow_tabbar == 1 ? true : false
        });
      },
      // 客服弹窗
      help() {
        Dialog.alert({
          title: "帮助中心",
          message: this.basic.help_content,
        }).then(() => {});
      },
      // 公告弹窗
      msg() {
        Notify({
          type: "success",
          message: this.basic.announce ? this.basic.announce : "暂无通知",
        });
      },
    },
  };
</script>

<style scoped lang="less">
  .van-tabbar {
    /* box-shadow: 1px 1px 5px #f5f6f7; */
    box-shadow: 0 0 10px 0 hsla(0, 6%, 58%, .6);

    
  }

  .page-suspend {
    position: fixed;
    bottom: 65px;
    right: 20px;

    .item {
      width: 1.1rem;
      height: 1.1rem;
      background: rgba(0, 0, 0, 0.4);
      color: #ffffff;
      text-align: center;
      // line-height: 30px;
      margin-bottom: 10px;
      border-radius: 5px;

      .iconfont {
        font-size: .46rem;
      }

      p {
        height: .3rem;
        font-size: .2rem;
      }
    }
  }
</style>